export enum MetricNames {
	WORKFORCE = 'workforce',
	WORKER_HOIST_TIME = 'workerHoistTime',
	MANAGER_RATIO = 'managerRatio',
	ACTIVITIES_COMPLETION_RATE_ON_TIME_TREND = 'activitiesCompletionRateOnTimeTrend',
	ACTIVITIES_COMPLETION_RATE_ON_TIME = 'activitiesCompletionRateOnTime',
}
